import Swal from "sweetalert2";
import { featureAccess } from "@/config/features";
import { authGet } from "@/core/services/auth-storage";

export function canAccess(feature) {
  try {
    const subscriptionData = authGet('subscription');
    let subscription;
    
    // Handle both string and object cases
    if (typeof subscriptionData === 'string') {
      subscription = JSON.parse(subscriptionData);
    } else if (typeof subscriptionData === 'object' && subscriptionData !== null) {
      subscription = subscriptionData;
    } else {
      subscription = null;
    }
    
    const plan = subscription?.plan?.name || 'Free';
    return featureAccess[feature]?.includes(plan);
  } catch (e) {
    console.error('Subscription parse error:', e);
    return false;
  }
}

/** Growth (2), Pro (5), Enterprise (unlimited) */
export function canUseMultilocations() {
  return (
    canAccess('twoLocations') ||
    canAccess('fiveLocations') ||
    canAccess('multilocations')
  );
}

const Subscription = {
  install(Vue) {
    // Get parsed subscription data
    Vue.prototype.$getSubscription = function () {
      try {
        const subscriptionData = authGet('subscription');
        let subscription;
        
        // Handle both string and object cases
        if (typeof subscriptionData === 'string') {
          subscription = JSON.parse(subscriptionData);
        } else if (typeof subscriptionData === 'object' && subscriptionData !== null) {
          subscription = subscriptionData;
        } else {
          subscription = null;
        }
        
        return subscription || null;
      } catch (e) {
        console.error('Subscription parse error:', e);
        return null;
      }
    };

    // Get plan name
    Vue.prototype.$getPlanName = function () {
      const sub = this.$getSubscription();
      return sub?.plan?.name || 'N/A';
    };

    // Get plan price
    Vue.prototype.$getPlanPrice = function () {
      const sub = this.$getSubscription();
      return sub?.plan?.price || '0.00';
    };

    // Check if subscription is active
    Vue.prototype.$hasActiveSubscription = function () {
      const sub = this.$getSubscription();
      return sub?.status === 'active';
    };

Vue.prototype.$hasPaidActiveSubscription = function () {
  const sub = this.$getSubscription();

  const price = parseFloat(sub?.plan?.price ?? "0");

  return sub?.status === "active" && price > 0;
};



    // Get plan features as array
    Vue.prototype.$getPlanFeatures = function () {
      const sub = this.$getSubscription();
      try {
        return JSON.parse(sub?.plan?.features || '[]');
      } catch (e) {
        console.error('Feature parse error:', e);
        return [];
      }
    };
    Vue.prototype.$redirectToBilling = function () {
      this.$router.push('/system-setting/billing');
    };
    Vue.prototype.$canUseMultilocations = function () {
      return canUseMultilocations();
    };
    Vue.prototype.$canAccess = function (feature) {
      return canAccess(feature);
    };

    Vue.prototype.$checkPlan = function () {
      // Paid plans that support multi-location tooling (Growth+)
      if (canUseMultilocations() || ['Starter', 'Growth', 'Pro', 'Enterprise'].includes(this.$getPlanName())) {
        return true;
      }
      this.$showUpgradeAlert();
      return false;
    };
    Vue.prototype.$showUpgradeAlert = function () {
      Swal.fire({
        title: "Upgrade Required",
        text: "This feature is only available for Premium and Pro plans. Please upgrade your plan to access this functionality.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Upgrade Plan",
        cancelButtonText: "Cancel",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-secondary",
        buttonsStyling: false,
        heightAuto: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$redirectToBilling();
        }
      });
    }
  }
};

export default Subscription;
